export default __webpack_public_path__ + "static/media/peregrine.56b9f849.png";